<ng-container [ngSwitch]="elementType">
  <ng-container *ngSwitchCase="'icon'">
    <ng-template *ngTemplateOutlet="iconButton"></ng-template>
  </ng-container>
  <ng-container *ngSwitchCase="'link'">
    <ng-template *ngTemplateOutlet="buttonAsLink"></ng-template>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <ng-template *ngTemplateOutlet="idpButtonTemplate"></ng-template>
  </ng-container>
</ng-container>

<ng-template #idpButtonTemplate>
  <button
    #idpButton
    (click)="notifyClick()"
    [attr.aria-haspopup]="ariaPopup"
    [attr.aria-label]="ariaLabel"
    [attr.aria-expanded]="ariaExpand"
    [attr.role]="role"
    [class.idp-btn--space]="bottomSpace"
    [class.idp-btn-md-large]="mdChangeWidth"
    [class.idp-btn-remove-after-content]="removeAfterContent"
    [disabled]="disabled"
    [id]="id"
    [innerHTML]="label"
    [ngClass]="getClasses()"
    [style.backgroundImage]="iconPath ? ' url(' + iconPath + ')' : ''"
    class="idp-btn"
    type="{{ elementType }}"
    [attr.data-cy]="'idp-button-' + label"
  ></button>
  <i *ngIf="displayIcon" aria-hidden="true" class="idp-display-icon">&nbsp;</i>
</ng-template>
<ng-template #iconButton>
  <a
    (click)="notifyClick()"
    (keydown.Enter)="notifyClick()"
    aria-haspopup="true"
    class="idp-icon-info-anchor"
    href="javascript:void(0)"
  >
    <i aria-hidden="true" class="idp-icon-info"></i>
    <span class="sr-only">opens popup</span>
  </a>
</ng-template>
<ng-template #buttonAsLink>
  <a
    (click)="notifyClick()"
    (keyup.Space)="notifyClick()"
    class="idp-link"
    href="javascript:void(0)"
    role="button"
  >
    {{ label }}
  </a>
</ng-template>
